import { Type } from "@sinclair/typebox";
import { Nullable, NullableString } from "../../utils/typeboxTypes";
export const DeviceTypeSchema = Type.Union([
    Type.Literal("ANDROID"),
    Type.Literal("IOS"),
    Type.Literal("WEB"),
]);
export const MsgrDeviceStatusSchema = Type.Union([Type.Literal("idle"), Type.Literal("active"), Type.Literal("offline")], { default: "idle" });
export const MsgrDeviceSchema = Type.Object({
    id: Type.Number(),
    uid: Type.String({ maxLength: 50 }),
    person_id: Type.Number(),
    type: DeviceTypeSchema,
    status: MsgrDeviceStatusSchema,
    is_validated: Type.Boolean({ default: false }),
    is_guest: Type.Boolean({ default: false }),
    validated_at: Nullable(Type.Date({ default: () => null })),
    info: NullableString,
    meta_data: NullableString,
    last_active_at: Nullable(Type.Date({ default: () => null })),
    last_offline_at: Nullable(Type.Date({ default: () => null })),
    created_at: Nullable(Type.Date({ default: () => new Date() })),
    updated_at: Nullable(Type.Date({ default: () => new Date() })),
    deleted_at: Nullable(Type.Date({ default: () => null })),
});
// 1	id	bigint(20)	NULL	NULL	NO	NULL	auto_increment
// 2	uid	varchar(50)	utf8mb4	utf8mb4_unicode_ci	NO	NULL
// 3	person_id	bigint(20)	NULL	NULL	YES	NULL		people(id)
// 4	type	varchar(255)	utf8mb4	utf8mb4_unicode_ci	NO	NULL
// 5	status	varchar(255)	utf8mb4	utf8mb4_unicode_ci	NO	NULL
// 6	is_validated	tinyint(1)	NULL	NULL	NO	0
// 7	validated_at	datetime	NULL	NULL	YES	NULL
// 8	info	json	NULL	NULL	YES	NULL
// 9	meta_data	json	NULL	NULL	YES	NULL
// 10	last_active_at	datetime	NULL	NULL	YES	NULL
// 11	last_offline_at	datetime	NULL	NULL	YES	NULL
// 12	created_at	timestamp	NULL	NULL	YES	NULL
// 13	updated_at	timestamp	NULL	NULL	YES	NULL
// 14	deleted_at	timestamp	NULL	NULL	YES	NULL
